module.exports = __webpack_public_path__ + "static/media/alert-triangle.57e00de9.svg";